document.addEventListener('alpine:init', () => {
    Alpine.store('modals', {
        openModals: new Set(),

        // Check if the modal is open
        isOpen(id) {
            const status = this.openModals.has(id);
            console.log(`isOpen(${id}) -> ${status}`);
            return status;
        },

        // Open a modal by ID (optional: close other modals if needed)
        open(id, closeOthers = false) {
            if (closeOthers) {
                console.log(`open(${id}) -> Closing all other modals first.`);
                this.closeAll(); // Optionally clear all other modals
            }
            this.openModals.add(id);
            console.log(`open(${id}) -> Modal opened. Current open modals: ${[...this.openModals]}`);
        },

        // Close a modal by ID
        close(id) {
            this.openModals.delete(id);
            console.log(`close(${id}) -> Modal closed. Current open modals: ${[...this.openModals]}`);
        },

        // Close all modals
        closeAll() {
            this.openModals.clear();
            console.log('closeAll() -> All modals closed.');
        },

        // Toggle a modal (open if closed, close if open)
        toggle(id) {
            if (this.isOpen(id)) {
                console.log(`toggle(${id}) -> Modal is open, closing it.`);
                this.close(id);
            } else {
                console.log(`toggle(${id}) -> Modal is closed, opening it.`);
                this.open(id);
            }
        }
    });
});
